import { useBlogArticleSelectors } from "../../../../../store/blogArticle/blogArticle.selectors";

import ArticleNavigation from "../../../../../components/common/ArticleNavigation";
import { OtherArticles } from "../OtherArticles/OtherArticles";
import { PersonalProxies } from "../PersonalProxies/PersonalProxies";

import { ArticleWrapper, Wrapper } from "./SideBar.styled";

const SideBar = () => {
  const { data } = useBlogArticleSelectors();

  return (
    <Wrapper>
      {data?.anchors?.length > 1 && (
        <ArticleWrapper>
          <ArticleNavigation showIcon={false} anchors={data?.anchors} />
        </ArticleWrapper>
      )}

      <OtherArticles />

      <PersonalProxies />
    </Wrapper>
  );
};

export default SideBar;
